import ZDSubmitData from './ZDSubmitData'

export default ZDSubmitData
